import { Component, Inject, Injectable, Optional } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})

export class SnackBarService {

  durationInSeconds = 1;

  constructor(
    private dialog: MatDialog
  ) { }

  showSnack(message: string) {
    let ref = this.dialog.open(DialogMessageComponent, {
      data: message,
      maxWidth: '500px'
    });
    setTimeout(()=>{ref.close()}, 10000)
  }
}

@Component({
  selector: 'dialog-message',
  template: `
  <div mat-dialog-content [innerHTML]="data"></div>
  `
})

export class DialogMessageComponent {
  constructor(
    @Optional()
    @Inject(MAT_DIALOG_DATA) public data
  ){}
}